import { ArrowUpRightIcon, LinkIcon } from 'lucide-react';
import { OverflowMenu } from '@/components/ui/menu';
import { formatCopy } from '@/i18n/ns';
import { useCanvasCopy } from './canvas-copy';
import { openAgent, wayBackFor, type AgentWayBack } from './everywhere/agent-link';

/**
 * The canvas header's "⋯": copy the link, and one "Open in <agent>" for each of the
 * person's connected agents with a web home (everywhere/agent-link.ts), once the
 * item has loaded and only for the kinds of item an agent can open.
 */
export function CanvasMoreMenu({
  kind,
  loaded,
  wayBack,
  onCopyLink,
  open = openAgent,
}: {
  kind: string | undefined;
  loaded: boolean;
  wayBack: AgentWayBack[];
  onCopyLink: () => void;
  open?: (agent: AgentWayBack) => unknown;
}) {
  const canvasCopy = useCanvasCopy();
  return (
    <OverflowMenu
      label={canvasCopy.more}
      items={[
        {
          key: 'copy-link',
          label: canvasCopy.copyLink,
          icon: <LinkIcon aria-hidden="true" />,
          onSelect: onCopyLink,
        },
        ...wayBackFor(kind, loaded, wayBack).map((agent) => ({
          key: `open-in-${agent.origin}`,
          label: formatCopy(canvasCopy.openInAgent, { agent: agent.name }),
          description: agent.host,
          icon: <ArrowUpRightIcon aria-hidden="true" />,
          onSelect: () => open(agent),
        })),
      ]}
    />
  );
}
